var render, staticRenderFns
import script from "./SecurityVerification.vue?vue&type=script&lang=js"
export * from "./SecurityVerification.vue?vue&type=script&lang=js"
import style0 from "./SecurityVerification.vue?vue&type=style&index=0&id=981b54cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981b54cc",
  null
  
)

export default component.exports